import React, { useEffect, useState } from "react";
import { CloseIcon } from "../../../components/Icons";
import { StyledBookAVisitButton } from "../../../components/LayoutApp/LayoutApp.style";
import { useModal } from "../../../context/ModalContext";
import { RadioGroup, FormControlLabel, Radio, FormControl, TextField } from "@mui/material";
import { MODALS } from "../../../config/params";
import { useRetirePetStore } from "../../../hooks/redux-hooks/pet-retire-store/pet-retire-store";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { userActivityLogger } from "../../../utils/mixpanel";

const ClosePetModal = () => {
  const { openModal, closeModal } = useModal();
  const [selectedReason, setSelectedReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const { petName, retireReason, reasonDescription, setRetireReason, setReasonDescription } = useRetirePetStore();

  const handleContinueClick = () => {
    if (selectedReason === "Other" && otherReason) {
      setRetireReason(selectedReason);
      setReasonDescription(otherReason);
      userActivityLogger(MIXPANEL_EVENTS.SELECT_REASON_RETIRE_PET,
        {
          pet_name: petName,
          reason_selected: `${selectedReason}: ${otherReason}`,
        });
      openModal(MODALS.CLOSE_PET_CONFIRMATION);
    } else if (selectedReason) {
      setRetireReason(selectedReason);
      userActivityLogger(MIXPANEL_EVENTS.SELECT_REASON_RETIRE_PET,
        {
          pet_name: petName,
          reason_selected: selectedReason,
        });
      openModal(MODALS.CLOSE_PET_CONFIRMATION);
    } else {
      return;
    }
  };

  const handleReasonChange = (event: any) => {
    setSelectedReason(event.target.value);
    if (event.target.value !== "Other") {
      setOtherReason("");
      setReasonDescription("");
    }
  };

  const handleModalClose = () => {
    userActivityLogger(MIXPANEL_EVENTS.EXIT_RETIRE_PET_FLOW,
      {
        pet_name: petName,
        cancelled_page: "reason",
      });
    closeModal();
  };

  useEffect(()=>{
    if (retireReason) {
      if (retireReason === "Other" && reasonDescription.length > 0) {
        setSelectedReason(retireReason);
        setOtherReason(reasonDescription);
      } else {
        setSelectedReason(retireReason);
      }
    }
  }, []);

  return (
    <div className="h-full p-3">
      <div className="h-full flex flex-col items-center gap-6">
        <div onClick={handleModalClose} className="w-full flex justify-end cursor-pointer">
          <CloseIcon />
        </div>
        <div className="flex-1 flex flex-col gap-4 w-full">
          <div className="flex flex-col gap-2 items-center">
            <div className="text-2xl font-semibold">Close Pet Profile</div>
            <div className="text-base px-2 flex flex-col items-center">
              <div>Please select the reason for updating</div>
              <div>{`${petName}’s profile`}</div>
            </div>
          </div>
          <div className="flex-1">
            <div className={`flex-1 bg-white md:max-h-[16.5rem] 2xl:max-h-96 
            ${selectedReason === "Other" ?"overflow-y-scroll": "overflow-y-hidden"} scroll-hide
            border border-gray-3 p-4 rounded-lg flex flex-col gap-2.5`}>
              <div className="font-semibold">Select a reason</div>
              <FormControl component="fieldset">
                <RadioGroup
                  aria-label="reason"
                  name="reason"
                  value={selectedReason}
                  onChange={handleReasonChange}
                  className="flex flex-col gap-2.5"
                >
                  <FormControlLabel
                    value="No longer their owner"
                    control={<Radio />}
                    label="No longer their owner"
                    className={`border rounded-lg py-2 !ms-0 ${selectedReason==="No longer their owner" ?
                      "!bg-gv-yellow-light border-2 border-gv-yellow" :"border-taupe-50"}`}
                  />
                  <FormControlLabel
                    value="Deceased"
                    control={<Radio />}
                    label="Deceased"
                    className={`border rounded-lg py-2 !ms-0 ${selectedReason==="Deceased" ?
                      "!bg-gv-yellow-light border-2 border-gv-yellow" :"border-taupe-50"}`}
                  />
                  <div className={`w-full !me-3.5 border py-2 rounded-lg ${selectedReason==="Other" ?
                    "!bg-gv-yellow-light border-2 border-gv-yellow" :"border-taupe-50"}`}>
                    <FormControlLabel
                      value="Other"
                      control={<Radio />}
                      label="Other"
                      className="w-full !ms-0"
                    />
                    <div className="px-3">
                      {selectedReason === "Other" && (
                        <TextField
                          placeholder="Type your reason..."
                          variant="outlined"
                          className="!bg-white !rounded-lg"
                          fullWidth
                          value={otherReason}
                          onChange={(e) => setOtherReason(e.target.value)}
                          multiline
                          maxRows={4}
                        />
                      )}
                    </div>
                  </div>
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div>
        <div className="w-full !sticky bottom-0">
          <StyledBookAVisitButton
            isOpenSidebar={true}
            color="primary"
            size="small"
            disabled={!selectedReason || (selectedReason === "Other" && !otherReason)}
            onClick={handleContinueClick}
            className="!m-0 w-full !text-sm"
          >
            Continue
          </StyledBookAVisitButton>
        </div>
      </div>
    </div>
  );
};

export default ClosePetModal;
